import { tagServices } from './../../../../services/';
import { alertActions } from './../../../alert/redux/actions';

import { actionTypes } from './types';
import OpenFieldTypes from 'OpenFieldTypes';

export const selectTagsAction = {
  getTags,
};

function getTags() {
  return (dispatch: OpenFieldTypes.RootAction) => {
      tagServices.getTags()
            .then(
                (tags) => {
                  dispatch(success(tags));
                },
                (error) => {
                  dispatch(failure(error.toString()));
                  dispatch(alertActions.errorAlert(error.toString()));
                },
            );
    };

  function success(data: any) { return { type: actionTypes.TAG_LIST_SUCCESS, data }; }
  function failure(error: string) { return { type: actionTypes.TAG_LIST_FAILURE, error }; }
}
